import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=1cf1f030&"
import script from "./BasicInformation.vue?vue&type=script&lang=ts&"
export * from "./BasicInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports